import './styles/PreValue.css'

function PreValue() {
    return (
        <div className="PreValue-Container fade-in-up" id='value'>
                <h3>A segurança em altura NÃO permite achismos!</h3>

                <h3>Domine o cálculo do fator de queda e zona livre de queda e assegure a verdadeira proteção da sua equipe em trabalhos em altura.</h3>
        </div>
    )
}

export default PreValue;